// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\np {\n    font-size: 16px;\n}\n.h2,\nh2 {\n    font-size: 1.8rem;\n}\n", ""]);
// Exports
module.exports = exports;
